export default function SendEmailSkeleton() {
  return (
    <div className="w-full max-w-md mx-auto mt-10 animate-pulse">
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-5">
        {/* Title */}
        <div className="space-y-2">
          <div className="h-6 w-40 bg-gray-200 rounded" />
          <div className="h-4 w-64 bg-gray-200 rounded" />
        </div>

        {/* Input */}
        <div className="space-y-2">
          <div className="h-4 w-32 bg-gray-200 rounded" />
          <div className="h-10 bg-gray-200 rounded-lg" />
        </div>

        {/* Select */}
        <div className="space-y-2">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-10 bg-gray-200 rounded-lg" />
        </div>

        {/* Subject */}
        <div className="space-y-2">
          <div className="h-4 w-20 bg-gray-200 rounded" />
          <div className="h-10 bg-gray-200 rounded-lg" />
        </div>

        {/* Message */}
        <div className="space-y-2">
          <div className="h-4 w-24 bg-gray-200 rounded" />
          <div className="h-24 bg-gray-200 rounded-lg" />
        </div>

        {/* Button */}
        <div className="flex justify-end pt-2">
          <div className="h-10 w-32 bg-gray-300 rounded-lg" />
        </div>
      </div>
    </div>
  )
}
